/* Native product media + editable review slots. No cart or purchase mutations. */
if (!customElements.get('kb-product-gallery')) customElements.define('kb-product-gallery', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.slides = [...this.querySelectorAll('[data-gallery-slide]')].filter(slide => {
      if (slide.hasAttribute('data-placeholder') && this.dataset.showPlaceholders !== 'true') { slide.hidden = true; return false; }
      return true;
    });
    this.index = 0;
    const nav = this.querySelector('.kb-gallery__navigation'), thumbs = this.querySelector('.kb-gallery__thumbs');
    this.buttons = this.slides.map((slide, index) => {
      const button = document.createElement('button'); button.type = 'button';
      const label = slide.dataset.label || `Product view ${index + 1}`;
      button.setAttribute('aria-label', `Show ${label}`);
      const source = slide.querySelector('img');
      if (source) { const image = document.createElement('img'); const url = new URL(source.currentSrc || source.src, location.href); url.searchParams.set('width', '160'); image.src = url.href; image.alt = ''; image.loading = 'lazy'; image.width = 72; image.height = 72; button.append(image); }
      else { button.textContent = slide.hasAttribute('data-placeholder') ? label : '▶ ' + label; }
      button.addEventListener('click', () => this.show(index));
      button.addEventListener('keydown', event => {
        let target;
        if (event.key === 'ArrowRight') target = (index + 1) % this.slides.length;
        if (event.key === 'ArrowLeft') target = (index - 1 + this.slides.length) % this.slides.length;
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = this.slides.length - 1;
        if (target !== undefined) { event.preventDefault(); this.show(target); this.buttons[target].focus(); }
      });
      if (/dimensions/i.test(label)) { const caption = document.createElement('span'); caption.className = 'kb-gallery__thumb-label'; caption.textContent = label; button.append(caption); }
      thumbs.append(button); return button;
    });
    nav.hidden = this.slides.length < 2;
    this.querySelector('[data-gallery-prev]').addEventListener('click', () => this.show((this.index - 1 + this.slides.length) % this.slides.length));
    this.querySelector('[data-gallery-next]').addEventListener('click', () => this.show((this.index + 1) % this.slides.length));
    const dialog = this.querySelector('dialog');
    this.querySelector('[data-gallery-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => this.opener?.focus());
    this.querySelectorAll('[data-gallery-image]').forEach(link => link.addEventListener('click', event => {
      event.preventDefault(); this.opener = link;
      const target = dialog.querySelector('img'); target.src = link.href; target.alt = link.querySelector('img').alt || this.getAttribute('aria-label'); dialog.showModal();
    }));
    this.addEventListener('shopify:block:select', event => {
      const slide = event.target.closest('[data-gallery-slide]');
      const index = this.slides.indexOf(slide);
      if (index >= 0) this.show(index);
    });
    // Swiping image/placeholder slides never interferes with video controls.
    this.querySelector('.kb-gallery__slides').addEventListener('touchstart', event => { this.touchX = event.touches[0].clientX; }, {passive:true});
    this.querySelector('.kb-gallery__slides').addEventListener('touchend', event => {
      if (event.target.closest('video,iframe,model-viewer') || this.touchX == null) return;
      const distance = event.changedTouches[0].clientX - this.touchX; this.touchX = null;
      if (Math.abs(distance) > 65 && this.slides.length > 1) this.show((this.index + (distance < 0 ? 1 : -1) + this.slides.length) % this.slides.length);
    }, {passive:true});
    this.show(0, false);
  }
  show(index, announce = true) {
    this.index = index;
    this.slides.forEach((slide, i) => {
      const wasVisible = !slide.hidden; slide.hidden = i !== index;
      if (i !== index) {
        slide.querySelectorAll('video').forEach(video => video.pause());
        if (wasVisible) slide.querySelectorAll('iframe').forEach(frame => { frame.src = frame.src; });
      }
    });
    this.buttons.forEach((button, i) => button.setAttribute('aria-current', i === index ? 'true' : 'false'));
    if (announce && this.slides[index]) this.querySelector('[role="status"]').textContent = `View ${index + 1} of ${this.slides.length}: ${this.slides[index].dataset.label}`;
  }
});
